import React from 'react'
import styled from 'styled-components';

import NoteItem from './NoteItem';

const LastNoteDate = styled.div`
    width:100%;
    background: none;
    font-size:0.8rem;
    text-align:center;
    color: #AAA;
    margin: 0.5rem 0;
`;

const ListOfNodes = styled.div`
    overflow:hidden;
    width: 100%;
    overflow-y: scroll;
    max-height: 100%; 
    position: relative;
    padding-bottom:0.7rem;
`;
export const ListOfNotes = ({currentUser, setNotes, notes, category, itemId}) => {
    
    let lastNoteDate = null;
    let showDate = true;
    const setLastNoteDate = (date)=>{
        lastNoteDate = new Date(date);
        showDate=true;
    }
    const editNote = (editedNote) => {
        // Use functional update to avoid stale `notes` closures
        setNotes((prev) => {
            const arr = Array.isArray(prev) ? prev : [];
            return arr.map((n) => (n?.id === editedNote?.id ? editedNote : n));
        });
    }
    const removeNote = (noteToRemove) => {
        // Use functional update to avoid stale `notes` closures
        setNotes((prev) => {
            const arr = Array.isArray(prev) ? prev : [];
            return arr.filter((n) => n?.id !== noteToRemove?.id);
        });
    }
    return <ListOfNodes id='notesView' >
        {notes == null ? <></> : notes.map((note, index) => 
    
            <div key={note?.id || index}> 
                {(lastNoteDate == null || new Date(lastNoteDate.toDateString()) < new Date(new Date(note.dateTime).toDateString()))? setLastNoteDate(note.dateTime):null}
            
                { showDate ? <LastNoteDate>{lastNoteDate.toLocaleString('default', { month: 'long' }) + ' ' + lastNoteDate.getDate()}</LastNoteDate> : null}
                {showDate = false}
                <NoteItem note={note} currentUser={currentUser} objectType={Array.isArray(category)?note.type:category} objectId={Array.isArray(category)?note.subjectId:itemId} editNote={editNote} removeNote={removeNote} />
            </ div>
            
)}
        <div />
    </ListOfNodes>
}

export function scrollNotesView(targer){
    targer.scrollTo({
        top: targer.clientHeight*100,
        left: 0,
        behavior: 'smooth'
    });
} 